<template>
  <a
    v-if="helpLink"
    :href="helpLink"
    target="_blank"
    class="flex font-normal text-placeholderGray hover:text-black active:text-placeholderGray font-body text-12"
    data-test="help-link"
    :data-ec="dataEc"
    data-et="help_link"
  >
    {{ $t('ui.steps.whatsThis') }}
    <ArrowUpRightFromSquareIcon class="ml-xs" />
  </a>
  <button
    v-else-if="helpscoutArticle"
    class="p-0 flex bg-transparent border-none cursor-pointer underline font-normal text-placeholderGray hover:text-black active:text-placeholderGray font-body text-12"
    data-test="helpscout-article"
    :data-ec="dataEc"
    data-et="helpscout_article"
    :data-beacon-article="helpscoutArticle"
  >
    {{ $t('ui.steps.whatsThis') }}
    <ArrowUpRightFromSquareIcon class="ml-xs pointer-events-none" />
  </button>
</template>

<script>
import { ArrowUpRightFromSquareIcon } from '@/components/library/icons';

export default {
  name: 'HelpLink',
  components: { ArrowUpRightFromSquareIcon },
  props: {
    helpLink: {
      type: String,
    },
    helpscoutArticle: {
      type: String,
    },
    dataEc: {
      type: String,
      required: true,
    },
  },
};
</script>
